import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.Measurements.RecoveredAggregateDryMassRetained`]: wrap([
    `${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
    `${prefix}.Measurements.FinePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.Measurements.RetainedMass_ExtraSieve`]: wrap([
    `${prefix}.Measurements.ContainerMass_ExtraSieve`,
    `${prefix}.Measurements.ContainerAndRetainedMass_ExtraSieve`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
